import { AccidentModel } from '@fleet-beat/api';

export const accidentsListDayMock: AccidentModel[] = [
  {
    driverId: '1',
    mistakes: 2,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1, 0),
  },
  {
    driverId: '1',
    mistakes: 1,
    violations: 1,
    sos: 4,
    date: new Date(2024, 0, 1, 1),
  },
  {
    driverId: '1',
    mistakes: 1,
    violations: 4,
    sos: 3,
    date: new Date(2024, 0, 1, 2),
  },
  {
    driverId: '1',
    mistakes: 4,
    violations: 3,
    sos: 7,
    date: new Date(2024, 0, 1, 3),
  },
  {
    driverId: '1',
    mistakes: 8,
    violations: 7,
    sos: 1,
    date: new Date(2024, 0, 1, 4),
  },
  {
    driverId: '1',
    mistakes: 3,
    violations: 6,
    sos: 0,
    date: new Date(2024, 0, 1, 5),
  },
  {
    driverId: '1',
    mistakes: 5,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 1, 6),
  },
  {
    driverId: '1',
    mistakes: 8,
    violations: 5,
    sos: 10,
    date: new Date(2024, 0, 1, 7),
  },
  {
    driverId: '1',
    mistakes: 1,
    violations: 1,
    sos: 10,
    date: new Date(2024, 0, 1, 8),
  },
  {
    driverId: '1',
    mistakes: 5,
    violations: 2,
    sos: 5,
    date: new Date(2024, 0, 1, 9),
  },
  {
    driverId: '1',
    mistakes: 6,
    violations: 4,
    sos: 10,
    date: new Date(2024, 0, 1, 10),
  },
  {
    driverId: '1',
    mistakes: 9,
    violations: 5,
    sos: 0,
    date: new Date(2024, 0, 1, 11),
  },
  {
    driverId: '1',
    mistakes: 0,
    violations: 5,
    sos: 1,
    date: new Date(2024, 0, 1, 12),
  },
  {
    driverId: '1',
    mistakes: 5,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1, 13),
  },
  {
    driverId: '1',
    mistakes: 2,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1, 14),
  },
  {
    driverId: '1',
    mistakes: 10,
    violations: 10,
    sos: 4,
    date: new Date(2024, 0, 1, 15),
  },
  {
    driverId: '1',
    mistakes: 10,
    violations: 4,
    sos: 3,
    date: new Date(2024, 0, 1, 16),
  },
  {
    driverId: '1',
    mistakes: 4,
    violations: 3,
    sos: 7,
    date: new Date(2024, 0, 1, 17),
  },
  {
    driverId: '1',
    mistakes: 8,
    violations: 7,
    sos: 10,
    date: new Date(2024, 0, 1, 18),
  },
  {
    driverId: '1',
    mistakes: 3,
    violations: 6,
    sos: 0,
    date: new Date(2024, 0, 1, 19),
  },
  {
    driverId: '1',
    mistakes: 5,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 1, 20),
  },
  {
    driverId: '1',
    mistakes: 8,
    violations: 5,
    sos: 10,
    date: new Date(2024, 0, 1, 21),
  },
  {
    driverId: '1',
    mistakes: 10,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 1, 22),
  },
  {
    driverId: '1',
    mistakes: 5,
    violations: 2,
    sos: 5,
    date: new Date(2024, 0, 1, 23),
  },
  {
    driverId: '2',
    mistakes: 8,
    violations: 5,
    sos: 10,
    date: new Date(2024, 0, 1, 0),
  },
  {
    driverId: '2',
    mistakes: 1,
    violations: 1,
    sos: 12,
    date: new Date(2024, 0, 1, 1),
  },
  {
    driverId: '2',
    mistakes: 5,
    violations: 2,
    sos: 5,
    date: new Date(2024, 0, 1, 2),
  },
  {
    driverId: '2',
    mistakes: 6,
    violations: 4,
    sos: 1,
    date: new Date(2024, 0, 1, 3),
  },
  {
    driverId: '2',
    mistakes: 9,
    violations: 5,
    sos: 0,
    date: new Date(2024, 0, 1, 4),
  },
  {
    driverId: '2',
    mistakes: 0,
    violations: 5,
    sos: 10,
    date: new Date(2024, 0, 1, 5),
  },
  {
    driverId: '2',
    mistakes: 5,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1, 6),
  },
  {
    driverId: '2',
    mistakes: 2,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1, 7),
  },
  {
    driverId: '2',
    mistakes: 10,
    violations: 10,
    sos: 4,
    date: new Date(2024, 0, 1, 8),
  },
  {
    driverId: '2',
    mistakes: 10,
    violations: 4,
    sos: 3,
    date: new Date(2024, 0, 1, 9),
  },
  {
    driverId: '2',
    mistakes: 12,
    violations: 3,
    sos: 7,
    date: new Date(2024, 0, 1, 10),
  },
  {
    driverId: '2',
    mistakes: 8,
    violations: 7,
    sos: 1,
    date: new Date(2024, 0, 1, 11),
  },
  {
    driverId: '2',
    mistakes: 3,
    violations: 6,
    sos: 0,
    date: new Date(2024, 0, 1, 12),
  },
  {
    driverId: '2',
    mistakes: 5,
    violations: 1,
    sos: 10,
    date: new Date(2024, 0, 1, 13),
  },
  {
    driverId: '2',
    mistakes: 8,
    violations: 5,
    sos: 11,
    date: new Date(2024, 0, 1, 14),
  },
  {
    driverId: '2',
    mistakes: 10,
    violations: 11,
    sos: 10,
    date: new Date(2024, 0, 1, 15),
  },
  {
    driverId: '2',
    mistakes: 5,
    violations: 2,
    sos: 5,
    date: new Date(2024, 0, 1, 16),
  },
  {
    driverId: '2',
    mistakes: 6,
    violations: 4,
    sos: 10,
    date: new Date(2024, 0, 1, 17),
  },
  {
    driverId: '2',
    mistakes: 9,
    violations: 5,
    sos: 0,
    date: new Date(2024, 0, 1, 18),
  },
  {
    driverId: '2',
    mistakes: 0,
    violations: 5,
    sos: 10,
    date: new Date(2024, 0, 1, 19),
  },
  {
    driverId: '2',
    mistakes: 5,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1, 20),
  },
  {
    driverId: '2',
    mistakes: 2,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1, 21),
  },
  {
    driverId: '2',
    mistakes: 10,
    violations: 10,
    sos: 4,
    date: new Date(2024, 0, 1, 22),
  },
  {
    driverId: '2',
    mistakes: 10,
    violations: 4,
    sos: 3,
    date: new Date(2024, 0, 1, 23),
  },
  {
    driverId: '3',
    mistakes: 2,
    violations: 0,
    sos: 1,
    date: new Date(2024, 0, 1, 0),
  },
  {
    driverId: '3',
    mistakes: 1,
    violations: 1,
    sos: 4,
    date: new Date(2024, 0, 1, 1),
  },
  {
    driverId: '3',
    mistakes: 1,
    violations: 4,
    sos: 3,
    date: new Date(2024, 0, 1, 2),
  },
  {
    driverId: '3',
    mistakes: 4,
    violations: 3,
    sos: 7,
    date: new Date(2024, 0, 1, 3),
  },
  {
    driverId: '3',
    mistakes: 8,
    violations: 7,
    sos: 1,
    date: new Date(2024, 0, 1, 4),
  },
  {
    driverId: '3',
    mistakes: 3,
    violations: 6,
    sos: 0,
    date: new Date(2024, 0, 1, 5),
  },
  {
    driverId: '3',
    mistakes: 5,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 1, 6),
  },
  {
    driverId: '3',
    mistakes: 8,
    violations: 5,
    sos: 10,
    date: new Date(2024, 0, 1, 7),
  },
  {
    driverId: '3',
    mistakes: 1,
    violations: 1,
    sos: 10,
    date: new Date(2024, 0, 1, 8),
  },
  {
    driverId: '3',
    mistakes: 5,
    violations: 2,
    sos: 5,
    date: new Date(2024, 0, 1, 9),
  },
  {
    driverId: '3',
    mistakes: 6,
    violations: 4,
    sos: 10,
    date: new Date(2024, 0, 1, 10),
  },
  {
    driverId: '3',
    mistakes: 9,
    violations: 5,
    sos: 0,
    date: new Date(2024, 0, 1, 11),
  },
  {
    driverId: '3',
    mistakes: 0,
    violations: 5,
    sos: 1,
    date: new Date(2024, 0, 1, 12),
  },
  {
    driverId: '3',
    mistakes: 5,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1, 13),
  },
  {
    driverId: '3',
    mistakes: 2,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1, 14),
  },
  {
    driverId: '3',
    mistakes: 10,
    violations: 10,
    sos: 4,
    date: new Date(2024, 0, 1, 15),
  },
  {
    driverId: '3',
    mistakes: 10,
    violations: 4,
    sos: 3,
    date: new Date(2024, 0, 1, 16),
  },
  {
    driverId: '3',
    mistakes: 4,
    violations: 3,
    sos: 7,
    date: new Date(2024, 0, 1, 17),
  },
  {
    driverId: '3',
    mistakes: 8,
    violations: 7,
    sos: 10,
    date: new Date(2024, 0, 1, 18),
  },
  {
    driverId: '3',
    mistakes: 3,
    violations: 6,
    sos: 0,
    date: new Date(2024, 0, 1, 19),
  },
  {
    driverId: '3',
    mistakes: 5,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 1, 20),
  },
  {
    driverId: '3',
    mistakes: 8,
    violations: 5,
    sos: 10,
    date: new Date(2024, 0, 1, 21),
  },
  {
    driverId: '3',
    mistakes: 10,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 1, 22),
  },
  {
    driverId: '3',
    mistakes: 5,
    violations: 2,
    sos: 5,
    date: new Date(2024, 0, 1, 23),
  },
  {
    driverId: '4',
    mistakes: 8,
    violations: 5,
    sos: 10,
    date: new Date(2024, 0, 1, 0),
  },
  {
    driverId: '4',
    mistakes: 1,
    violations: 1,
    sos: 10,
    date: new Date(2024, 0, 1, 1),
  },
  {
    driverId: '4',
    mistakes: 5,
    violations: 2,
    sos: 5,
    date: new Date(2024, 0, 1, 2),
  },
  {
    driverId: '4',
    mistakes: 6,
    violations: 4,
    sos: 10,
    date: new Date(2024, 0, 1, 3),
  },
  {
    driverId: '4',
    mistakes: 9,
    violations: 5,
    sos: 0,
    date: new Date(2024, 0, 1, 4),
  },
  {
    driverId: '4',
    mistakes: 0,
    violations: 5,
    sos: 10,
    date: new Date(2024, 0, 1, 5),
  },
  {
    driverId: '4',
    mistakes: 5,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1, 6),
  },
  {
    driverId: '4',
    mistakes: 2,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1, 7),
  },
  {
    driverId: '4',
    mistakes: 10,
    violations: 10,
    sos: 4,
    date: new Date(2024, 0, 1, 8),
  },
  {
    driverId: '4',
    mistakes: 10,
    violations: 4,
    sos: 3,
    date: new Date(2024, 0, 1, 9),
  },
  {
    driverId: '4',
    mistakes: 12,
    violations: 3,
    sos: 7,
    date: new Date(2024, 0, 1, 10),
  },
  {
    driverId: '4',
    mistakes: 8,
    violations: 7,
    sos: 1,
    date: new Date(2024, 0, 1, 11),
  },
  {
    driverId: '4',
    mistakes: 3,
    violations: 6,
    sos: 0,
    date: new Date(2024, 0, 1, 12),
  },
  {
    driverId: '4',
    mistakes: 5,
    violations: 1,
    sos: 10,
    date: new Date(2024, 0, 1, 13),
  },
  {
    driverId: '4',
    mistakes: 8,
    violations: 5,
    sos: 10,
    date: new Date(2024, 0, 1, 14),
  },
  {
    driverId: '4',
    mistakes: 10,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 1, 15),
  },
  {
    driverId: '4',
    mistakes: 5,
    violations: 2,
    sos: 5,
    date: new Date(2024, 0, 1, 16),
  },
  {
    driverId: '4',
    mistakes: 6,
    violations: 4,
    sos: 10,
    date: new Date(2024, 0, 1, 17),
  },
  {
    driverId: '4',
    mistakes: 9,
    violations: 5,
    sos: 0,
    date: new Date(2024, 0, 1, 18),
  },
  {
    driverId: '4',
    mistakes: 0,
    violations: 5,
    sos: 10,
    date: new Date(2024, 0, 1, 19),
  },
  {
    driverId: '4',
    mistakes: 5,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1, 20),
  },
  {
    driverId: '4',
    mistakes: 2,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1, 21),
  },
  {
    driverId: '4',
    mistakes: 10,
    violations: 10,
    sos: 4,
    date: new Date(2024, 0, 1, 22),
  },
  {
    driverId: '4',
    mistakes: 10,
    violations: 4,
    sos: 3,
    date: new Date(2024, 0, 1, 23),
  },
  {
    driverId: '5',
    mistakes: 2,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1, 0),
  },
  {
    driverId: '5',
    mistakes: 1,
    violations: 1,
    sos: 4,
    date: new Date(2024, 0, 1, 1),
  },
  {
    driverId: '5',
    mistakes: 1,
    violations: 4,
    sos: 3,
    date: new Date(2024, 0, 1, 2),
  },
  {
    driverId: '5',
    mistakes: 4,
    violations: 3,
    sos: 7,
    date: new Date(2024, 0, 1, 3),
  },
  {
    driverId: '5',
    mistakes: 8,
    violations: 7,
    sos: 1,
    date: new Date(2024, 0, 1, 4),
  },
  {
    driverId: '5',
    mistakes: 3,
    violations: 6,
    sos: 0,
    date: new Date(2024, 0, 1, 5),
  },
  {
    driverId: '5',
    mistakes: 5,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 1, 6),
  },
  {
    driverId: '5',
    mistakes: 8,
    violations: 5,
    sos: 10,
    date: new Date(2024, 0, 1, 7),
  },
  {
    driverId: '5',
    mistakes: 1,
    violations: 1,
    sos: 10,
    date: new Date(2024, 0, 1, 8),
  },
  {
    driverId: '5',
    mistakes: 5,
    violations: 2,
    sos: 5,
    date: new Date(2024, 0, 1, 9),
  },
  {
    driverId: '5',
    mistakes: 6,
    violations: 4,
    sos: 10,
    date: new Date(2024, 0, 1, 10),
  },
  {
    driverId: '5',
    mistakes: 9,
    violations: 5,
    sos: 0,
    date: new Date(2024, 0, 1, 11),
  },
  {
    driverId: '5',
    mistakes: 0,
    violations: 5,
    sos: 1,
    date: new Date(2024, 0, 1, 12),
  },
  {
    driverId: '5',
    mistakes: 5,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1, 13),
  },
  {
    driverId: '5',
    mistakes: 2,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1, 14),
  },
  {
    driverId: '5',
    mistakes: 10,
    violations: 10,
    sos: 4,
    date: new Date(2024, 0, 1, 15),
  },
  {
    driverId: '5',
    mistakes: 10,
    violations: 4,
    sos: 3,
    date: new Date(2024, 0, 1, 16),
  },
  {
    driverId: '5',
    mistakes: 4,
    violations: 3,
    sos: 7,
    date: new Date(2024, 0, 1, 17),
  },
  {
    driverId: '5',
    mistakes: 8,
    violations: 7,
    sos: 10,
    date: new Date(2024, 0, 1, 18),
  },
  {
    driverId: '5',
    mistakes: 3,
    violations: 6,
    sos: 0,
    date: new Date(2024, 0, 1, 19),
  },
  {
    driverId: '5',
    mistakes: 5,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 1, 20),
  },
  {
    driverId: '5',
    mistakes: 8,
    violations: 5,
    sos: 10,
    date: new Date(2024, 0, 1, 21),
  },
  {
    driverId: '5',
    mistakes: 10,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 1, 22),
  },
  {
    driverId: '5',
    mistakes: 5,
    violations: 2,
    sos: 5,
    date: new Date(2024, 0, 1, 23),
  },
];

export const accidentsListWeekMock: AccidentModel[] = [
  {
    driverId: '1',
    mistakes: 20,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 1),
  },
  {
    driverId: '1',
    mistakes: 10,
    violations: 10,
    sos: 40,
    date: new Date(2024, 0, 2),
  },
  {
    driverId: '1',
    mistakes: 10,
    violations: 40,
    sos: 30,
    date: new Date(2024, 0, 3),
  },
  {
    driverId: '1',
    mistakes: 40,
    violations: 30,
    sos: 70,
    date: new Date(2024, 0, 4),
  },
  {
    driverId: '1',
    mistakes: 80,
    violations: 70,
    sos: 10,
    date: new Date(2024, 0, 5),
  },
  {
    driverId: '1',
    mistakes: 30,
    violations: 60,
    sos: 0,
    date: new Date(2024, 0, 6),
  },
  {
    driverId: '1',
    mistakes: 50,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 7),
  },
  {
    driverId: '2',
    mistakes: 80,
    violations: 50,
    sos: 10,
    date: new Date(2024, 0, 1),
  },
  {
    driverId: '2',
    mistakes: 10,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 2),
  },
  {
    driverId: '2',
    mistakes: 50,
    violations: 20,
    sos: 50,
    date: new Date(2024, 0, 3),
  },
  {
    driverId: '2',
    mistakes: 60,
    violations: 40,
    sos: 10,
    date: new Date(2024, 0, 4),
  },
  {
    driverId: '2',
    mistakes: 90,
    violations: 50,
    sos: 0,
    date: new Date(2024, 0, 5),
  },
  {
    driverId: '2',
    mistakes: 0,
    violations: 50,
    sos: 10,
    date: new Date(2024, 0, 6),
  },
  {
    driverId: '2',
    mistakes: 50,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 7),
  },
  {
    driverId: '3',
    mistakes: 20,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 1),
  },
  {
    driverId: '3',
    mistakes: 10,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 2),
  },
  {
    driverId: '3',
    mistakes: 10,
    violations: 40,
    sos: 30,
    date: new Date(2024, 0, 3),
  },
  {
    driverId: '3',
    mistakes: 40,
    violations: 30,
    sos: 70,
    date: new Date(2024, 0, 4),
  },
  {
    driverId: '3',
    mistakes: 80,
    violations: 70,
    sos: 10,
    date: new Date(2024, 0, 5),
  },
  {
    driverId: '3',
    mistakes: 30,
    violations: 60,
    sos: 0,
    date: new Date(2024, 0, 6),
  },
  {
    driverId: '3',
    mistakes: 50,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 7),
  },
  {
    driverId: '4',
    mistakes: 80,
    violations: 50,
    sos: 10,
    date: new Date(2024, 0, 1),
  },
  {
    driverId: '4',
    mistakes: 10,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 2),
  },
  {
    driverId: '4',
    mistakes: 50,
    violations: 20,
    sos: 50,
    date: new Date(2024, 0, 3),
  },
  {
    driverId: '4',
    mistakes: 60,
    violations: 40,
    sos: 10,
    date: new Date(2024, 0, 4),
  },
  {
    driverId: '4',
    mistakes: 90,
    violations: 50,
    sos: 0,
    date: new Date(2024, 0, 5),
  },
  {
    driverId: '4',
    mistakes: 10,
    violations: 50,
    sos: 10,
    date: new Date(2024, 0, 6),
  },
  {
    driverId: '4',
    mistakes: 50,
    violations: 0,
    sos: 0,
    date: new Date(2024, 0, 7),
  },
  {
    driverId: '5',
    mistakes: 20,
    violations: 30,
    sos: 40,
    date: new Date(2024, 0, 1),
  },
  {
    driverId: '5',
    mistakes: 10,
    violations: 10,
    sos: 40,
    date: new Date(2024, 0, 2),
  },
  {
    driverId: '5',
    mistakes: 10,
    violations: 40,
    sos: 30,
    date: new Date(2024, 0, 3),
  },
  {
    driverId: '5',
    mistakes: 40,
    violations: 30,
    sos: 70,
    date: new Date(2024, 0, 4),
  },
  {
    driverId: '5',
    mistakes: 80,
    violations: 70,
    sos: 10,
    date: new Date(2024, 0, 5),
  },
  {
    driverId: '5',
    mistakes: 30,
    violations: 60,
    sos: 0,
    date: new Date(2024, 0, 6),
  },
  {
    driverId: '5',
    mistakes: 50,
    violations: 10,
    sos: 10,
    date: new Date(2024, 0, 7),
  },
];

export const accidentsListAllTimeMock: AccidentModel[] = [
  {
    driverId: '1',
    mistakes: 120,
    violations: 90,
    sos: 100,
    date: new Date(2023, 0),
  },
  {
    driverId: '1',
    mistakes: 100,
    violations: 100,
    sos: 140,
    date: new Date(2023, 1),
  },
  {
    driverId: '1',
    mistakes: 100,
    violations: 140,
    sos: 130,
    date: new Date(2023, 2),
  },
  {
    driverId: '1',
    mistakes: 140,
    violations: 130,
    sos: 170,
    date: new Date(2023, 3),
  },
  {
    driverId: '1',
    mistakes: 180,
    violations: 170,
    sos: 110,
    date: new Date(2023, 4),
  },
  {
    driverId: '1',
    mistakes: 130,
    violations: 160,
    sos: 100,
    date: new Date(2023, 5),
  },
  {
    driverId: '1',
    mistakes: 150,
    violations: 110,
    sos: 110,
    date: new Date(2023, 6),
  },
  {
    driverId: '1',
    mistakes: 180,
    violations: 150,
    sos: 110,
    date: new Date(2023, 7),
  },
  {
    driverId: '1',
    mistakes: 110,
    violations: 110,
    sos: 110,
    date: new Date(2023, 8),
  },
  {
    driverId: '1',
    mistakes: 150,
    violations: 120,
    sos: 150,
    date: new Date(2023, 9),
  },
  {
    driverId: '1',
    mistakes: 160,
    violations: 140,
    sos: 110,
    date: new Date(2023, 10),
  },
  {
    driverId: '1',
    mistakes: 190,
    violations: 150,
    sos: 100,
    date: new Date(2023, 11),
  },
  {
    driverId: '2',
    mistakes: 80,
    violations: 50,
    sos: 10,
    date: new Date(2023, 0),
  },
  {
    driverId: '2',
    mistakes: 10,
    violations: 10,
    sos: 10,
    date: new Date(2023, 1),
  },
  {
    driverId: '2',
    mistakes: 50,
    violations: 20,
    sos: 50,
    date: new Date(2023, 2),
  },
  {
    driverId: '2',
    mistakes: 60,
    violations: 40,
    sos: 10,
    date: new Date(2023, 3),
  },
  {
    driverId: '2',
    mistakes: 90,
    violations: 50,
    sos: 0,
    date: new Date(2023, 4),
  },
  {
    driverId: '2',
    mistakes: 0,
    violations: 50,
    sos: 10,
    date: new Date(2023, 5),
  },
  {
    driverId: '2',
    mistakes: 50,
    violations: 0,
    sos: 0,
    date: new Date(2023, 6),
  },
  {
    driverId: '2',
    mistakes: 20,
    violations: 0,
    sos: 0,
    date: new Date(2023, 7),
  },
  {
    driverId: '2',
    mistakes: 10,
    violations: 10,
    sos: 40,
    date: new Date(2023, 8),
  },
  {
    driverId: '2',
    mistakes: 10,
    violations: 40,
    sos: 30,
    date: new Date(2023, 9),
  },
  {
    driverId: '2',
    mistakes: 40,
    violations: 30,
    sos: 70,
    date: new Date(2023, 10),
  },
  {
    driverId: '2',
    mistakes: 80,
    violations: 70,
    sos: 10,
    date: new Date(2023, 11),
  },
  {
    driverId: '3',
    mistakes: 80,
    violations: 60,
    sos: 70,
    date: new Date(2023, 0),
  },
  {
    driverId: '3',
    mistakes: 60,
    violations: 70,
    sos: 80,
    date: new Date(2023, 1),
  },
  {
    driverId: '3',
    mistakes: 70,
    violations: 80,
    sos: 90,
    date: new Date(2023, 2),
  },
  {
    driverId: '3',
    mistakes: 80,
    violations: 90,
    sos: 100,
    date: new Date(2023, 3),
  },
  {
    driverId: '3',
    mistakes: 90,
    violations: 100,
    sos: 110,
    date: new Date(2023, 4),
  },
  {
    driverId: '3',
    mistakes: 100,
    violations: 110,
    sos: 120,
    date: new Date(2023, 5),
  },
  {
    driverId: '3',
    mistakes: 110,
    violations: 120,
    sos: 130,
    date: new Date(2023, 6),
  },
  {
    driverId: '3',
    mistakes: 120,
    violations: 130,
    sos: 140,
    date: new Date(2023, 7),
  },
  {
    driverId: '3',
    mistakes: 130,
    violations: 140,
    sos: 150,
    date: new Date(2023, 8),
  },
  {
    driverId: '3',
    mistakes: 140,
    violations: 150,
    sos: 160,
    date: new Date(2023, 9),
  },
  {
    driverId: '3',
    mistakes: 150,
    violations: 160,
    sos: 170,
    date: new Date(2023, 10),
  },
  {
    driverId: '3',
    mistakes: 160,
    violations: 170,
    sos: 180,
    date: new Date(2023, 11),
  },
  {
    driverId: '4',
    mistakes: 160,
    violations: 100,
    sos: 80,
    date: new Date(2023, 0),
  },
  {
    driverId: '4',
    mistakes: 130,
    violations: 120,
    sos: 110,
    date: new Date(2023, 1),
  },
  {
    driverId: '4',
    mistakes: 150,
    violations: 110,
    sos: 110,
    date: new Date(2023, 2),
  },
  {
    driverId: '4',
    mistakes: 180,
    violations: 150,
    sos: 110,
    date: new Date(2023, 3),
  },
  {
    driverId: '4',
    mistakes: 110,
    violations: 110,
    sos: 110,
    date: new Date(2023, 4),
  },
  {
    driverId: '4',
    mistakes: 150,
    violations: 120,
    sos: 150,
    date: new Date(2023, 5),
  },
  {
    driverId: '4',
    mistakes: 160,
    violations: 140,
    sos: 110,
    date: new Date(2023, 6),
  },
  {
    driverId: '4',
    mistakes: 190,
    violations: 150,
    sos: 100,
    date: new Date(2023, 7),
  },
  {
    driverId: '4',
    mistakes: 120,
    violations: 90,
    sos: 100,
    date: new Date(2023, 8),
  },
  {
    driverId: '4',
    mistakes: 100,
    violations: 100,
    sos: 140,
    date: new Date(2023, 9),
  },
  {
    driverId: '4',
    mistakes: 100,
    violations: 140,
    sos: 130,
    date: new Date(2023, 10),
  },
  {
    driverId: '4',
    mistakes: 140,
    violations: 130,
    sos: 170,
    date: new Date(2023, 11),
  },
  {
    driverId: '5',
    mistakes: 120,
    violations: 90,
    sos: 100,
    date: new Date(2023, 0),
  },
  {
    driverId: '5',
    mistakes: 100,
    violations: 100,
    sos: 140,
    date: new Date(2023, 1),
  },
  {
    driverId: '5',
    mistakes: 100,
    violations: 140,
    sos: 130,
    date: new Date(2023, 2),
  },
  {
    driverId: '5',
    mistakes: 140,
    violations: 130,
    sos: 170,
    date: new Date(2023, 3),
  },
  {
    driverId: '5',
    mistakes: 180,
    violations: 170,
    sos: 110,
    date: new Date(2023, 4),
  },
  {
    driverId: '5',
    mistakes: 130,
    violations: 160,
    sos: 100,
    date: new Date(2023, 5),
  },
  {
    driverId: '5',
    mistakes: 150,
    violations: 110,
    sos: 110,
    date: new Date(2023, 6),
  },
  {
    driverId: '5',
    mistakes: 180,
    violations: 150,
    sos: 110,
    date: new Date(2023, 7),
  },
  {
    driverId: '5',
    mistakes: 110,
    violations: 110,
    sos: 110,
    date: new Date(2023, 8),
  },
  {
    driverId: '5',
    mistakes: 150,
    violations: 120,
    sos: 150,
    date: new Date(2023, 9),
  },
  {
    driverId: '5',
    mistakes: 160,
    violations: 140,
    sos: 110,
    date: new Date(2023, 10),
  },
  {
    driverId: '5',
    mistakes: 190,
    violations: 150,
    sos: 100,
    date: new Date(2023, 11),
  },
];
